import { AuthenticationService } from './../authentication.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { CustomValidators } from 'src/app/shared/Validators/custom-validators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {


  public forgotPasswordForm: FormGroup; // our model dri
  title: any
  success: boolean = false;
  successmsg: string;
  constructor(private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private customLoadingService: CustomLoadingService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {

    var routerClassName = "";
    this.activatedRoute
      .data
      .subscribe(data => {

        routerClassName = data["activeClass"];
        document.getElementById('body').className = routerClassName;
        this.title = data["title"] || "HRDirect BalanceBenefits";
      });

    this.forgotPasswordForm = this.formBuilder.group({
      Email: ['', Validators.compose([Validators.required, CustomValidators.email])]
    });

  }

  forgotPassword(model: any, isValid: boolean) {
    if (isValid) {
      this.customLoadingService.show();

      this.authenticationService.sendPassword(model.Email)
        .subscribe(response => {
          this.success = true;
          this.successmsg = response;
          this.customLoadingService.hide();
          this.forgotPasswordForm.reset();
          this.forgotPasswordForm.clearValidators();
        },
          error => {

            this.success = false;
            this.customLoadingService.hide();
          },
          ///() => { this.route.navigate([this.appSettingService.landingScreenUrl]); }
        );
    }
  }


}

